var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "invoice-report" },
    [
      _c(
        "div",
        { staticClass: "invoice-report__table-wrapper" },
        [
          _c("div", { staticClass: "invoice-report__header" }, [
            _c("div", { staticClass: "invoice-grid invoice-grid--header" }, [
              _c("div", { staticClass: "invoice-header-cell" }, [
                _vm._v(" " + _vm._s(_vm.$t("lbl_unit_code")) + " ")
              ]),
              _c("div", { staticClass: "invoice-header-cell" }, [
                _vm._v(" " + _vm._s(_vm.$t("lbl_period")) + " ")
              ]),
              _c("div", { staticClass: "invoice-header-cell" }, [
                _vm._v(" " + _vm._s(_vm.$t("lbl_ar_invoice_number")) + " ")
              ]),
              _c("div", { staticClass: "invoice-header-cell" }, [
                _vm._v(" " + _vm._s(_vm.$t("lbl_invoice_date")) + " ")
              ]),
              _c("div", { staticClass: "invoice-header-cell" }, [
                _vm._v(" " + _vm._s(_vm.$t("lbl_ar_status")) + " ")
              ]),
              _c("div", { staticClass: "invoice-header-cell text-right" }, [
                _vm._v(" " + _vm._s(_vm.$t("lbl_invoice_amount")) + " ")
              ]),
              _c("div", { staticClass: "invoice-header-cell text-right" }, [
                _vm._v(" " + _vm._s(_vm.$t("lbl_outstanding")) + " ")
              ]),
              _c("div", { staticClass: "invoice-header-cell" }, [
                _vm._v(" " + _vm._s(_vm.$t("lbl_branch")) + " ")
              ])
            ])
          ]),
          _vm.loading
            ? [
                _vm._l(3, function(n) {
                  return [
                    _c("InvoiceRecurringReportTableCustomerSkeleton", {
                      key: "customer-skeleton-" + n
                    }),
                    _c("InvoiceRecurringReportTableContractSkeleton", {
                      key: "contract-skeleton-" + n
                    }),
                    _vm._l(4, function(x) {
                      return [
                        _c("InvoiceRecurringReportTableRowSkeleton", {
                          key: "sk-line-skeleton-" + n + "-" + x
                        })
                      ]
                    }),
                    _c("InvoiceRecurringReportTableSubTotalSkeleton", {
                      key: n
                    })
                  ]
                })
              ]
            : _vm.invoiceRecurringReports.length === 0
            ? [
                _c("div", { staticClass: "empty-state" }, [
                  _c(
                    "div",
                    { staticClass: "empty-state__content" },
                    [
                      _c("a-icon", {
                        staticClass: "empty-state__icon",
                        attrs: { type: "file" }
                      }),
                      _c("div", { staticClass: "empty-state__title" }, [
                        _vm._v(
                          " " + _vm._s(_vm.$t("notif_data_not_found")) + " "
                        )
                      ])
                    ],
                    1
                  )
                ])
              ]
            : [
                _c(
                  "div",
                  { staticClass: "invoice-horizontal" },
                  [
                    _c("DynamicScroller", {
                      staticClass: "invoice-scroller",
                      attrs: {
                        items: _vm.flattenedRows,
                        "min-item-size": 54,
                        "key-field": "id"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(ref) {
                            var item = ref.item
                            var index = ref.index
                            var active = ref.active
                            return [
                              _c(
                                "DynamicScrollerItem",
                                {
                                  attrs: {
                                    item: item,
                                    active: active,
                                    "data-index": index
                                  }
                                },
                                [
                                  item.type === "customer"
                                    ? _c(
                                        "div",
                                        { staticClass: "row-customer" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "row-customer__content"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row-customer--left"
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "expand-icon",
                                                      class: {
                                                        "expand-icon--collapsed": _vm.collapsedCustomers.includes(
                                                          item.customer
                                                            .customerName
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("a-icon", {
                                                        attrs: { type: "down" }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "row-customer__title",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.toggleCustomer(
                                                            item.customer
                                                              .customerName
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.truncateCustomer(
                                                              item.customer
                                                                .customerName
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "row-customer__count"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "lbl_contracts_count",
                                                              {
                                                                count:
                                                                  item.customer
                                                                    .contracts
                                                                    .length
                                                              }
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "row-customer__summary"
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t("lbl_invoice")
                                                        ) +
                                                        ": "
                                                    ),
                                                    _c("strong", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm._f("currency")(
                                                              item.customer
                                                                .subtotalInvoiceAmount
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "lbl_outstanding"
                                                          )
                                                        ) +
                                                        ": "
                                                    ),
                                                    _c("strong", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm._f("currency")(
                                                              item.customer
                                                                .subtotalOutstanding
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ])
                                                  ])
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : item.type === "contract"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "row-ic",
                                          on: {
                                            click: function($event) {
                                              return _vm.toggleIc(
                                                item.contract.icNo
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "row-ic__content" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "row-ic--left" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "expand-icon",
                                                      class: {
                                                        "expand-icon--collapsed": _vm.collapsedIcs.includes(
                                                          item.contract.icNo
                                                        )
                                                      }
                                                    },
                                                    [
                                                      _c("a-icon", {
                                                        attrs: { type: "down" }
                                                      })
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "row-ic__title"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.contract.icNo
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  ),
                                                  _c(
                                                    "a-tag",
                                                    {
                                                      attrs: { color: "blue" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.contract
                                                              .icStatus
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "row-ic__right"
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        item.contract
                                                          .rentPeriodRange
                                                      ) +
                                                      " "
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : item.type === "line"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "invoice-grid invoice-row"
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "invoice-cell" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "unit-wrapper" },
                                                [
                                                  _c("div", [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "unit-code"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              item.line.unitCode
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    ),
                                                    item.line.changeUnitHistory
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "change-history"
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.line
                                                                    .changeUnitHistory
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]),
                                                  item.line.isBackup
                                                    ? _c(
                                                        "a-tag",
                                                        {
                                                          attrs: {
                                                            color: "gold"
                                                          }
                                                        },
                                                        [_vm._v(" B ")]
                                                      )
                                                    : _vm._e(),
                                                  item.line.isEnded
                                                    ? _c(
                                                        "a-tag",
                                                        {
                                                          attrs: {
                                                            color: "red"
                                                          }
                                                        },
                                                        [_vm._v(" END ")]
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "invoice-cell" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.line.period) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "invoice-cell" },
                                            [
                                              item.line.invoiceArNo
                                                ? _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "invoice-link",
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.openInvoice(
                                                            item.line
                                                          )
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            item.line
                                                              .invoiceArNo
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                : _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "empty__value"
                                                    },
                                                    [_vm._v(" — ")]
                                                  )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "invoice-cell" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("date")(
                                                      item.line.invoiceDate
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "invoice-cell" },
                                            [
                                              item.line.invoiceArStatus
                                                ? _c(
                                                    "a-tag",
                                                    {
                                                      attrs: { color: "gray" }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.formatStatus(
                                                              item.line
                                                                .invoiceArStatus
                                                            )
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                : _c("span", [_vm._v("-")])
                                            ],
                                            1
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "invoice-cell text-right"
                                            },
                                            [
                                              item.line.invoiceAmount
                                                ? [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm._f("currency")(
                                                            item.line
                                                              .invoiceAmount
                                                          )
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                : [_vm._v(" - ")]
                                            ],
                                            2
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "invoice-cell text-right"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("currency")(
                                                      item.line.outstanding
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "invoice-cell" },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(item.line.branch) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : item.type === "subtotal"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "invoice-grid row-subtotal"
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "invoice-cell invoice-cell--subtotal subtotal-label"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("lbl_subtotal")
                                                  ) +
                                                  " " +
                                                  _vm._s(item.contract.icNo) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "invoice-cell invoice-cell--subtotal text-right"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("currency")(
                                                      item.contract
                                                        .subtotalInvoiceAmount
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "invoice-cell invoice-cell--subtotal text-right"
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm._f("currency")(
                                                      item.contract
                                                        .subtotalOutstanding
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ]
        ],
        2
      ),
      _c(
        "Modal",
        {
          attrs: {
            centered: false,
            dialogstyle: { top: "20px" },
            maskClosable: false,
            width: "60%",
            title: _vm.$t("lbl_invoice_ar_view"),
            showmodal: _vm.show.detailInvoice,
            idmodal: "invoice-recurring-report-detail"
          }
        },
        [
          _c(
            "div",
            { attrs: { slot: "contentmodal" }, slot: "contentmodal" },
            [
              _c("InvoiceRecurringReportDetailField", {
                ref: "detailField",
                attrs: {
                  loadingDetail: _vm.loadingDetail,
                  detailData: _vm.detailData
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footermodal" }, slot: "footermodal" },
            [
              _c("a-button", { on: { click: _vm.closePopupInvoiceDetail } }, [
                _vm._v(" " + _vm._s(_vm.$t("lbl_close")) + " ")
              ])
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }